import { default as ContactsSelect } from "./ContactsSelect";

export default ContactsSelect;